"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Footer_1 = __importDefault(require("./Footer"));
const Header_1 = __importDefault(require("./Header"));
const pages = [
    { route: "home", name: "Accueil" },
    { route: "datasets", name: "Datasets" },
];
const Page = ({ children, pageList = pages, currentLink = "home", showLeftLogo = true, disableFooter = false, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { currentLink: currentLink, pageList: pageList, showLogoLeft: showLeftLogo }),
        children,
        disableFooter || react_1.default.createElement(Footer_1.default, null)));
};
exports.default = Page;
